import { StyledCheckbox } from './Checkbox.styles';
import { CheckboxProps as BaseCheckboxProps } from '@mui/material/Checkbox';
import React, { ChangeEvent } from 'react';

export interface CheckboxProps extends BaseCheckboxProps {
  /**
   * If true, the component is checked.
   */
  checked: boolean;
  /**
   * Optional change handler.
   */
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  colorOverride?: string;
  'data-testid'?: string;
}

/**
 * Allowing the user to select a checkbox.
 */
export const Checkbox: React.FC<CheckboxProps> = ({
  onChange,
  checked,
  colorOverride,
  ...props
}: CheckboxProps) => {
  return (
    <StyledCheckbox
      checked={checked}
      onChange={onChange}
      {...(colorOverride
        ? { style: { color: colorOverride } }
        : { color: 'primary' })}
      inputProps={{
        'aria-label': 'secondary checkbox',
      }}
      {...props}
    />
  );
};

export default Checkbox;
